
import validator from 'validator';

const ValidateRejectedReason = (data) => {
    let errors = {};

    const {rejection_message } = data;

    if (validator.isEmpty(rejection_message)) {
        errors.rejection_message = '반려 사유를 선택해주세요';
    }
    // if (validator.isEmpty(job_id)) {
    //     errors.job_id = 'Please Select An User.';
    // }
    return {
        isInvalid: Object.keys(errors).length > 0,
        error: errors,
    };
};

export default ValidateRejectedReason;